import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

import IconButton from "@/components/buttons/IconButton";
import Table from "@/components/Table";
import Badge from "@/components/Badge";
import { complaintStatusIntent, complaintStatusLabel } from "@/utils/application-status";




const ComplaintListItem = ({complaint}:{complaint: any}) => {
    const navigate = useNavigate();

    const handleView = (id: string) => navigate(`/complaints/${id}`, {
        state: {
            id,
            complaint
        }
    })

    return (
        <Table.Row>
            <Table.Cell>
                {complaint.complaintId}
            </Table.Cell>
            <Table.Cell className="w-72">
                {complaint.subject}
            </Table.Cell>
            <Table.Cell>
                <div className="flex bg-zinc-100 text-zinc-500 rounded-lg px-2 py-0.5 max-w-max">
                    <span>{complaint.type}</span>
                </div>
            </Table.Cell>
            <Table.Cell>
                {complaint.submissionDate}
            </Table.Cell>
            <Table.Cell>
                    <Badge 
                            intent={complaintStatusIntent(complaint?.status)}
                            text={complaintStatusLabel(complaint?.status)} 
                            />
            </Table.Cell>
            <Table.Cell
                className={"flex items-center justify-center gap-3 opacity-80"}
            >
                <IconButton 
                    intent="secondary" 
                    className="border border-secondary-200"
                    onClick={() => handleView(complaint.complaintId)}
                >
                    <Eye 
                        className="size-4" 
                    />
                </IconButton>
            </Table.Cell>
        </Table.Row>
    )
}

export default ComplaintListItem